import styled from 'styled-components';

export const ContainerBannerImagem = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;

  img {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
    background-color: ${({ theme }) => theme.colors.neutral.neutral_alpha[3]};
  }
`;
